import {isNil, isNotNil} from 'ramda';

import type {EngineTechnicalData, VariantTechnicalData} from '@dms/api/new-vehicle';

import type {Nullish} from 'shared/web';

import {t} from './catalogueUi';

export const formatWithUnit = (value: string | number | Nullish, unitKey: string) =>
  isNil(value) ? undefined : `${value}\u00A0${t(unitKey)}`;

export const formatBatteryCapacity = (data: EngineTechnicalData | Nullish) =>
  formatWithUnit(data?.batteryCapacityWh, 'general.metric.kWh');

/** A plug-in hybrid shows its weighted values: only it has them, and its standard CO2 is not kept (D85). */
export const formatConsumptionAndEmission = (data: VariantTechnicalData | Nullish) =>
  [
    formatWithUnit(
      data?.fuelConsumptionWltpWeighted ?? data?.fuelConsumptionWltpCombined,
      'general.metric.l100km'
    ),
    formatWithUnit(
      data?.fuelConsumptionWltpWeightedCombinedKwh ?? data?.fuelConsumptionWltpCombinedKwh,
      'general.metric.kwh100km'
    ),
    formatWithUnit(
      data?.carbonDioxideEmissionWeightedCombined ?? data?.carbonDioxideEmission,
      'general.metric.gkm'
    ),
  ]
    .filter(isNotNil)
    .join(' · ');
